<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
    <div class="text-center">
      <div v-if="isLoading" class="space-y-4">
        <svg class="animate-spin h-12 w-12 text-indigo-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <h2 class="text-xl font-semibold text-gray-900">
          {{ $t('auth.callback.authenticating') }}
        </h2>
        <p class="text-gray-600">
          {{ $t('auth.callback.pleaseWait') }}
        </p>
      </div>
      
      <div v-else-if="error" class="space-y-4">
        <svg class="h-12 w-12 text-red-600 mx-auto" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
        </svg>
        <h2 class="text-xl font-semibold text-gray-900">
          {{ $t('auth.callback.error') }}
        </h2>
        <p class="text-gray-600">
          {{ error }}
        </p>
        <router-link to="/login" class="inline-block bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700">
          {{ $t('auth.callback.backToLogin') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../config/axios';

export default {
  name: 'AuthCallbackPage',
  data() {
    return {
      isLoading: true,
      error: null
    };
  },
  async mounted() {
    try {
      // Récupérer le token depuis l'URL
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      
      if (!token) {
        this.error = this.$t('auth.callback.noToken');
        this.isLoading = false;
        return;
      }

      // Sauvegarder le token
      localStorage.setItem('token', token);
      
      // Vérifier le token avec le backend
      const response = await axios.get('/auth/verify', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Sauvegarder les informations utilisateur
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      // Rediriger vers la page d'accueil
      this.$router.push('/');
      
    } catch (error) {
      console.error('Auth callback error:', error);
      this.error = this.$t('auth.callback.verificationFailed');
      this.isLoading = false;
    }
  }
};
</script> 